import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";

const patchPatient = async ({ patientId, data }) => {
  const token = localStorage.getItem("token");

  const response = await axios.patch(
    `${__API_URL__}/api/patient/patient/singlepatient/?patientId=${patientId}`,
    data,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const usePatchPatientMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchPatient,
    onSuccess: (_data, { patientId }) => {
      toast.success("Subject Data Updated!");
      queryClient.invalidateQueries({ queryKey: ["single_patient", patientId] });
    },
    onError: (error) => {
      console.error("Failed to update patient:", error);
    },
  });
};

export default usePatchPatientMutation;
